<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  name: 'DefaultApp',
  props: {}
};
</script>

<style lang="scss"></style>
